import React, { useRef } from "react";
import NotificationPopup from "./NotificationPopup";
import useNotifications from "./hooks/useNotifications";

const NotificationIcon = ({ className, style = {} }) => {
  const iconRef = useRef(null);
  const {
    isPopoverOpen,
    notificationImage,
    toggleNotificationPopover,
    closeNotificationPopover,
    loading,
    notificationData,
    hasUnreadNotifications,
    unreadCount,
  } = useNotifications();

  console.log("NotificationIcon - isPopoverOpen:", isPopoverOpen);
  console.log("NotificationIcon - unreadCount:", unreadCount);

  return (
    <div
      className={className || "notification-icon-container"}
      style={{
        display: "inline-block",
        cursor: "pointer",
        position: "relative",
        ...style,
      }}
    >
      <img
        ref={iconRef}
        src={notificationImage}
        className="img-fluid rounded-circle"
        alt="Notification"
        style={{
          maxWidth: "40px",
          width: "40px",
          height: "40px",
          cursor: "pointer",
          ...style.imageStyle,
        }}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          toggleNotificationPopover();
        }}
        fetchpriority="high"
        loading="eager"
        width="40"
        height="40"
      />

      {/* Optional: Add a badge showing unread count */}
      {unreadCount > 0 && (
        <span
          className="position-absolute top-1 start-100 translate-middle badge rounded-pill bg-danger d-flex align-items-center justify-content-center"
          style={{ fontSize: "0.7rem", minWidth: "18px", height: "18px" }}
        >
          {unreadCount > 99 ? "99+" : unreadCount}
        </span>
      )}

      <NotificationPopup
        isOpen={isPopoverOpen}
        onClose={closeNotificationPopover}
        title="Notifications"
        targetElement={iconRef.current}
        loading={loading}
        data={notificationData?.data || []}
        hasUnreadNotifications={hasUnreadNotifications}
        unreadCount={unreadCount}
      />
    </div>
  );
};

export default NotificationIcon;
